import React from "react";
export default function AiIndex() {
  return (
    <section className="ai-index-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <div className="ai-index-firstbox">
              <img src="/assets/images/ai-index-firstimg.webp" alt="first-image" />
              <span> AI Data Structuring & Indexing</span>
              <p>Convert unstructured documents into organized, searchable data using intelligent tagging, classification, metadata extraction.</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <div className="ai-index-secondbox">
              <img src="/assets/images/ai-index-secondbox-img.webp" alt="background" />

              <span> Delivering 
                <label><img src="/assets/images/ai-index-span-img.webp" alt="icon" />Scalable</label> 
              <br />
              Business Insights With
              <br />
              <img src="/assets/images/ai-index-span-img-2.webp" alt="icon" />-Ready Data <br />
                Modernization
              </span>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <div className="ai-index-thirdbox">
              <img src="/assets/images/ai-index-img-2.webp" alt="third-image" />
              <span>Data Integration & Modernization</span>
              <p>Integrate document data with your business systems to enable automation, real-time access, scalable decision-making.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}





